export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale/src/constant.js
// module id = BWYN
// module chunks = 0